import { MatBaoConnectionSettingsModal } from "../../customer/electronic-contract/modals/MatBaoConnectionSettingsModal";

export default function MatBaoSettingsPage() {
  return <div className="p-4">
    <MatBaoConnectionSettingsModal isModalOpen inline />
  </div>;
}
